import Layout from "../hocs/Layout";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get_categories } from "../redux/actions/categories";
import { get_products, get_filtered_products } from "../redux/actions/products";
import ProductCard from "../components/product/ProductCard";
import { prices } from "../helpers/fixedPrices";
import { IconFilter, IconMinus, IconPlus, IconX } from "@tabler/icons-react";

const Shop = ({
  get_categories,
  categories,
  get_products,
  products,
  get_filtered_products,
  filtered_products,
}) => {
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const [openPriceFiltersMobile, setOpenPriceFiltersMobile] = useState(false);
  const [openMoreFiltersMobile, setOpenMoreFiltersMobile] = useState(false);
  const [openPriceFiltersDesktop, setOpenPriceFiltersDesktop] = useState(false);
  const [openMoreFiltersDesktop, setOpenMoreFiltersDesktop] = useState(false);

  const [filtered, setFiltered] = useState(false);
  const [formData, setFormData] = useState({
    category_id: "0",
    price_range: "Todos",
    sortBy: "created",
    order: "desc",
  });

  const { category_id, price_range, sortBy, order } = formData;

  useEffect(() => {
    get_categories();
    get_products();
    window.scrollTo(0, 0);
  }, []);

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    get_filtered_products(category_id, price_range, sortBy, order);
    setFiltered(true);
    setMobileFiltersOpen(false);
  };

  const showProducts = () => {
    let results = [];
    let display = [];

    if (
      filtered_products &&
      filtered_products !== null &&
      filtered_products !== undefined &&
      filtered
    ) {
      filtered_products.map((product, index) => {
        return display.push(
          <div key={index}>
            <ProductCard product={product} />
          </div>,
        );
      });
    } else if (
      !filtered &&
      products &&
      products !== null &&
      products !== undefined
    ) {
      products.map((product, index) => {
        return display.push(
          <div key={index}>
            <ProductCard product={product} />
          </div>,
        );
      });
    }

    for (let i = 0; i < display.length; i += 3) {
      results.push(
        <div key={i} className="grid md:grid-cols-3 ">
          {display[i] ? display[i] : <div className=""></div>}
          {display[i + 1] ? display[i + 1] : <div className=""></div>}
          {display[i + 2] ? display[i + 2] : <div className=""></div>}
        </div>,
      );
    }

    return results;
  };

  const [openCategories, setOpenCategories] = useState({});
  const toggleCategory = (categoryId) => {
    setOpenCategories((prev) => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
  };

  const renderCategories = (categories) =>
    categories.map((category) => {
      const hasSubCategories = category.sub_categories.length > 0;
      return (
        <div key={category.id} className="my-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <input
                name="category_id"
                onChange={onChange}
                value={category.id.toString()}
                type="radio"
                className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded-full"
              />

              <label className="ml-3 text-gray-500">{category.name}</label>
            </div>
            {hasSubCategories && (
              <button
                type="button"
                onClick={() => toggleCategory(category.id)}
                className="ml-2"
              >
                {openCategories[category.id] ? (
                  <IconMinus className="h-5 w-5 text-gray-500" />
                ) : (
                  <IconPlus className="h-5 w-5 text-gray-500" />
                )}
              </button>
            )}
          </div>
          {hasSubCategories && openCategories[category.id] && (
            <div className="ml-6 mt-2">
              {renderCategories(category.sub_categories)}
            </div>
          )}
        </div>
      );
    });
  return (
    <Layout>
      <div className="bg-white">
        <div>
          {mobileFiltersOpen && (
            <div className="fixed inset-0 flex z-40 lg:hidden">
              <div
                className="fixed inset-0 bg-black bg-opacity-25"
                onClick={() => setMobileFiltersOpen(false)}
              ></div>
              <div className="ml-auto relative max-w-xs w-full h-full bg-white shadow-xl py-4 pb-12 flex flex-col overflow-y-auto">
                <div className="px-4 flex items-center justify-between">
                  <h2 className="text-lg font-medium text-gray-900">Filtros</h2>
                  <button
                    type="button"
                    className="-mr-2 w-10 h-10 bg-white p-2 rounded-md flex items-center justify-center text-gray-400"
                    onClick={() => setMobileFiltersOpen(false)}
                  >
                    <span className="sr-only">Close menu</span>
                    <IconX className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>

                <form
                  onSubmit={(e) => onSubmit(e)}
                  className="mt-4 border-t border-gray-200"
                >
                  <h3 className="sr-only">Categories</h3>
                  <ul
                    role="list"
                    className="font-medium text-gray-900 px-2 py-3"
                  >
                    {categories && renderCategories(categories)}
                  </ul>
                  <div className="border-t border-gray-200 px-4 py-6">
                    <div className="-mx-2 -my-3 flow-root">
                      <button
                        type="button"
                        className="px-2 py-3 bg-white w-full flex items-center justify-between text-gray-400 hover:text-gray-500"
                        onClick={() =>
                          setOpenPriceFiltersMobile(!openPriceFiltersMobile)
                        }
                      >
                        <span className="font-medium text-gray-900">
                          Precios
                        </span>
                        <span className="ml-6 flex items-center">
                          {openPriceFiltersMobile ? (
                            <IconMinus className="h-5 w-5" aria-hidden="true" />
                          ) : (
                            <IconPlus className="h-5 w-5" aria-hidden="true" />
                          )}
                        </span>
                      </button>
                    </div>
                    {openPriceFiltersMobile && (
                      <div className="pt-6">
                        <div className="space-y-6">
                          {prices &&
                            prices.map((price, index) => (
                              <div key={index} className="form-check">
                                <input
                                  onChange={(e) => onChange(e)}
                                  value={price.name}
                                  name="price_range"
                                  type="radio"
                                  className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded-full"
                                  defaultChecked={price.id === 0}
                                />

                                <label className="ml-3 min-w-0 flex-1 text-gray-500 font-sofiapro-light">
                                  {price.name}
                                </label>
                              </div>
                            ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="border-t border-gray-200 px-4 py-6">
                    <div className="-mx-2 -my-3 flow-root">
                      <button
                        type="button"
                        className="px-2 py-3 bg-white w-full flex items-center justify-between text-gray-400 hover:text-gray-500"
                        onClick={() =>
                          setOpenMoreFiltersMobile(!openMoreFiltersMobile)
                        }
                      >
                        <span className="font-medium text-gray-900">
                          Más Filtros
                        </span>
                        <span className="ml-6 flex items-center">
                          {openMoreFiltersMobile ? (
                            <IconMinus className="h-5 w-5" aria-hidden="true" />
                          ) : (
                            <IconPlus className="h-5 w-5" aria-hidden="true" />
                          )}
                        </span>
                      </button>
                    </div>
                    {openMoreFiltersMobile && (
                      <div className="pt-6">
                        <div className="space-y-6">
                          <div className="form-group">
                            <label
                              htmlFor="sortBy"
                              className="mr-3 min-w-0 flex-1 text-gray-500"
                            >
                              Ver por
                            </label>
                            <select
                              className="my-2 inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700"
                              id="sortBy"
                              name="sortBy"
                              onChange={(e) => onChange(e)}
                              value={sortBy}
                            >
                              <option value="">Selecciona una opcion</option>
                              <option value="date_created">Fecha</option>
                              <option value="price">Precio</option>
                              <option value="sold">Mas Vendido</option>
                              <option value="title">Nombre</option>
                            </select>
                          </div>
                          <div className="form-group">
                            <label
                              htmlFor="order"
                              className="mr-3 min-w-0 flex-1 text-gray-500"
                            >
                              Orden
                            </label>
                            <select
                              className="my-2 inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700"
                              id="order"
                              name="order"
                              onChange={(e) => onChange(e)}
                              value={order}
                            >
                              <option value="">Selecciona una opcion</option>
                              <option value="asc">A - Z</option>
                              <option value="desc">Z - A</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="float-right inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
                  >
                    Buscar
                  </button>
                </form>
              </div>
            </div>
          )}

          <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="relative z-10 flex items-baseline justify-between pt-24 pb-6 border-b border-gray-200">
              <h1 className="text-4xl font-extrabold tracking-tight text-gray-900">
                Tienda
              </h1>

              <div className="flex items-center">
                <button
                  type="button"
                  className="p-2 -m-2 ml-4 sm:ml-6 text-gray-400 hover:text-gray-500 lg:hidden"
                  onClick={() => setMobileFiltersOpen(true)}
                >
                  <span className="sr-only">Filtros</span>
                  <IconFilter className="w-5 h-5" aria-hidden="true" />
                </button>
              </div>
            </div>

            <section aria-labelledby="products-heading" className="pt-6 pb-24">
              <h2 id="products-heading" className="sr-only">
                Productos
              </h2>

              <div className="grid grid-cols-1 lg:grid-cols-4 gap-x-8 gap-y-10">
                <form onSubmit={(e) => onSubmit(e)} className="hidden lg:block">
                  <h2 className="text-2xl font-extrabold tracking-tight text-gray-900">
                    Categorias
                  </h2>
                  <ul
                    role="list"
                    className="text-sm font-medium text-gray-900 space-y-4 pb-6 border-b border-gray-200"
                  >
                    {categories && renderCategories(categories)}
                  </ul>
                  <div className="border-t border-gray-200 px-4 py-6">
                    <div className="-mx-2 -my-3 flow-root">
                      <button
                        type="button"
                        className="px-2 py-3 bg-white w-full flex items-center justify-between text-gray-400 hover:text-gray-500"
                        onClick={() =>
                          setOpenPriceFiltersDesktop(!openPriceFiltersDesktop)
                        }
                      >
                        <span className="font-medium text-gray-900">
                          Precios
                        </span>
                        <span className="ml-6 flex items-center">
                          {openPriceFiltersDesktop ? (
                            <IconMinus className="h-5 w-5" aria-hidden="true" />
                          ) : (
                            <IconPlus className="h-5 w-5" aria-hidden="true" />
                          )}
                        </span>
                      </button>
                    </div>
                    {openPriceFiltersDesktop && (
                      <div className="pt-6">
                        <div className="space-y-6">
                          {prices &&
                            prices.map((price, index) => (
                              <div key={index} className="form-check">
                                <input
                                  onChange={(e) => onChange(e)}
                                  value={price.name}
                                  name="price_range"
                                  type="radio"
                                  className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded-full"
                                  defaultChecked={price.id === 0}
                                />

                                <label className="ml-3 min-w-0 flex-1 text-gray-500 font-sofiapro-light">
                                  {price.name}
                                </label>
                              </div>
                            ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="border-t border-gray-200 px-4 py-6">
                    <div className="-mx-2 -my-3 flow-root">
                      <button
                        type="button"
                        className="px-2 py-3 bg-white w-full flex items-center justify-between text-gray-400 hover:text-gray-500"
                        onClick={() =>
                          setOpenMoreFiltersDesktop(!openMoreFiltersDesktop)
                        }
                      >
                        <span className="font-medium text-gray-900">
                          Más Filtros
                        </span>
                        <span className="ml-6 flex items-center">
                          {openMoreFiltersDesktop ? (
                            <IconMinus className="h-5 w-5" aria-hidden="true" />
                          ) : (
                            <IconPlus className="h-5 w-5" aria-hidden="true" />
                          )}
                        </span>
                      </button>
                    </div>
                    {openMoreFiltersDesktop && (
                      <div className="pt-6">
                        <div className="space-y-6">
                          <div className="form-group">
                            <label
                              htmlFor="sortBy"
                              className="mr-3 min-w-0 flex-1 text-gray-500"
                            >
                              Ver por
                            </label>
                            <select
                              className="my-2 inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700"
                              id="sortBy"
                              name="sortBy"
                              onChange={(e) => onChange(e)}
                              value={sortBy}
                            >
                              <option value="">Selecciona una opcion</option>
                              <option value="date_created">Fecha</option>
                              <option value="price">Precio</option>
                              <option value="sold">Mas Vendido</option>
                              <option value="title">Nombre</option>
                            </select>
                          </div>
                          <div className="form-group">
                            <label
                              htmlFor="order"
                              className="mr-3 min-w-0 flex-1 text-gray-500"
                            >
                              Orden
                            </label>
                            <select
                              className="my-2 inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700"
                              id="order"
                              name="order"
                              onChange={(e) => onChange(e)}
                              value={order}
                            >
                              <option value="">Selecciona una opcion</option>
                              <option value="asc">A - Z</option>
                              <option value="desc">Z - A</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="float-right inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
                  >
                    Buscar
                  </button>
                </form>

                <div className="lg:col-span-3">
                  {products && showProducts()}
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  categories: state.Categories.categories,
  products: state.Products.products,
  filtered_products: state.Products.filtered_products,
});

export default connect(mapStateToProps, {
  get_categories,
  get_products,
  get_filtered_products,
})(Shop);
